<div class="flex-fill d-flex flex-column recent-pack-slips">
    <div *ngIf="packingSlips" class="d-flex">
        <div class="column ms-2 me-3"><span class="color-legend needs-invoice"></span> - Needs Invoice</div>
        <div class="column ms-2 me-3"><span class="color-legend uncompleted-details"></span> - UnCompleted Details</div>
        <div class="column ms-2 me-3"><span class="color-legend needs-signed-packslip "></span> - Waiting For Signed PackSlip</div>
    </div>
    <div class="d-flex flex-fill m-1 p-1 col-sm-12">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            class="h-100 grid-fill"
            [dataSource]="packingSlips"
            [showBorders]="true"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellPrepared)="onCellPrepared($event)"
        >
            <dxi-column dataField="packingSlipNumber" caption="Slip #" width="80"></dxi-column>
            <dxi-column dataField="companyName" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="totalFreight" width="80" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="freightNotInvoiced" width="80"></dxi-column>
            <dxi-column dataField="hasNonInvoicedDetails" width="80"></dxi-column>
            <dxi-column dataField="unCompletedDetails" width="80" cellTemplate="orderLineDetailTemplate" ></dxi-column>
            <dxi-column dataField="hasUndeliveredDetails" width="80"></dxi-column>
            <dxi-column dataField="invoiceNumbers" caption="Invoices" width="80" cellTemplate="invoiceTemplate"></dxi-column>
            <dxi-column dataField="freightInvoiceNumber" caption="Freight Invoice" width="80" cellTemplate="freightInvoiceNumberTemplate" alignment="left" ></dxi-column>
            <dxi-column dataField="shipToCity" caption="ShipToCity" width="200"></dxi-column>
            <dxi-column dataField="deliveryMethod" width="150"></dxi-column>
            <dxi-column dataField="createDate" dataType="date" caption="Created" width="100"></dxi-column>
            <dxi-column dataField="maxDelivered" dataType="date" caption="Deliver Date (newest)" width="100"></dxi-column>
            <dxi-column dataField="freight" caption="PackSlip Freight"  width="80" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="invoicedFreight" caption="Invoiced Freight"  width="80" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let cell of 'orderLineDetailTemplate'">
                <a [routerLink]="[]" (click)="openBuildDetailsAsDialog(cell)">{{ cell.value }}</a>
            </div>
            <div *dxTemplate="let cell of 'freightInvoiceNumberTemplate'">
                <a [routerLink]="[]" (click)="openInvoiceNumber(cell.value)">{{ cell.value }}</a>
            </div>
            <div *dxTemplate="let cell of 'invoiceTemplate'">
                <a *ngFor="let invoiceNumber of cell.data.invoiceNumbers" [routerLink]="[]" (click)="openInvoiceNumber(invoiceNumber)">{{ invoiceNumber || '' }} </a>
            </div>

            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" [storageKey]="'packingSlip-search-grid'"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-secondary ms-2"
                    (click)="print(dataGrid.instance.getSelectedRowsData()[0].reportGuid)"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Print Slip
                </button>

                <button class="btn btn-success ms-2" (click)="editPackSlip()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Edit Pack Slip</button>
                <button class="btn btn-primary ms-2" (click)="markComplete()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Mark Complete</button>
                <button class="btn btn-danger ms-2" (click)="createInvoice()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Create Invoice</button>
                <button class="btn btn-sm btn-secondary ms-4" (click)="refresh()">Refresh Data</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="packingSlips" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
